import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=b8c81fa8&scoped=true"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=b8c81fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c81fa8",
  null
  
)

export default component.exports